<div>
   <ul class="financial_tab">
       <li [ngClass]="{'active': selectedTab === 0}" (click)="selectTab(0)">Per Share Data</li>
       <li [ngClass]="{'active': selectedTab === 1}" (click)="selectTab(1)">Ratios</li>
       <li [ngClass]="{'active': selectedTab === 2}" (click)="selectTab(2)">Statements</li>
   </ul>

   <div [ngClass]="{'d-none': selectedTab !== 0}" *ngIf="!isLoading">
      <app-ps-data [dividentPerShareArray]="dividentPerShareArray"
                   [ebitPerShareArray]="ebitPerShareArray"
                   [epsArray]="epsArray"
                   [revenuePerShare]="revenuePerShare"
                   [epsFwd]="epsFwd"
                   [ticker]="ticker"
                   [price_to_earning]="price_to_earning">
      </app-ps-data>
  </div>

  <div [ngClass]="{'d-none': selectedTab !== 1}">
      <app-ratios [chartKey]="ticker"
                  [price_to_earning]="price_to_earning"
                  [ticker]="ticker">
      </app-ratios>
  </div>



  <app-loader-component *ngIf="isLoading && selectedTab !== 2"></app-loader-component>


  <div *ngIf="selectedTab === 2">
      <app-f-statements [chartKey]="ticker"></app-f-statements>
  </div>



</div>
